import { create } from "zustand";

interface SupplierProcessingState {
  warehouse: string | null;
  search: string;
  ordering: string;
  status: string;
  isPinned: string;

  currentPage: number;
  pageSize: number;
  totalCount: number;

  selectedShipment: string | null;
  isModalOpen: boolean;

  setWarehouse: (warehouse: string) => void;
  setSearch: (search: string) => void;
  setOrdering: (ordering: string) => void;
  setStatus: (status: string) => void;
  setIsPinned: (isPinned: string) => void;
  setCurrentPage: (page: number) => void;
  setTotalCount: (totalCount: number) => void;

  openShipmentModal: (shipmentCode: string) => void;
  closeShipmentModal: () => void;

  resetFilters: () => void;

  getFilters: () => {
    warehouse: string | null;
    search: string;
    ordering: string;
    status: string;
    isPinned: string;
    currentPage: number;
    pageSize: number;
  };
}

export const useSupplierProcessingStore =
  create<SupplierProcessingState>((set, get) => ({
    warehouse: null,
    search: "",
    ordering: "-created_at",
    status: "",
    isPinned: "",

    currentPage: 1,
    pageSize: 10,
    totalCount: 0,

    selectedShipment: null,
    isModalOpen: false,

    setWarehouse: (warehouse) =>
      set((state) => {
        if (state.warehouse === warehouse) return state;

        return {
          warehouse,
          currentPage: 1,
        };
      }),

    setSearch: (search) =>
      set((state) => {
        if (state.search === search) return state;

        return {
          search,
          currentPage: 1,
        };
      }),

    setStatus: (status) =>
      set((state) => {
        if (state.status === status) return state;

        return {
          status,
          currentPage: 1,
        };
      }),

    setIsPinned: (isPinned) =>
      set((state) => {
        if (state.isPinned === isPinned) return state;

        return {
          isPinned,
          currentPage: 1,
        };
      }),

    setOrdering: (ordering) =>
      set((state) => {
        if (state.ordering === ordering) return state;

        return {
          ordering,
          currentPage: 1,
        };
      }),

    setCurrentPage: (currentPage) =>
      set((state) => {
        if (state.currentPage === currentPage) return state;

        return {
          currentPage,
        };
      }),

    setTotalCount: (totalCount) =>
      set((state) => {
        if (state.totalCount === totalCount) return state;

        return {
          totalCount,
        };
      }),

    openShipmentModal: (shipmentCode: string) =>
      set(() => ({
        selectedShipment: shipmentCode,
        isModalOpen: true,
      })),

    closeShipmentModal: () =>
      set(() => ({
        selectedShipment: null,
        isModalOpen: false,
      })),

    resetFilters: () =>
      set(() => ({
        warehouse: null,
        search: "",
        ordering: "-created_at",
        status: "",
        isPinned: "",
        currentPage: 1,
      })),

    getFilters: () => {
      const state = get();

      return {
        warehouse: state.warehouse,
        search: state.search,
        ordering: state.ordering,
        status: state.status,
        isPinned: state.isPinned,
        currentPage: state.currentPage,
        pageSize: state.pageSize,
      };
    },
  }));
